
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://zxkxyapayniimhpjetaa.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inp4a3h5YXBheW5paW1ocGpldGFhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDc5OTUzMjIsImV4cCI6MjA2MzU3MTMyMn0.VV7odKx4YQIM9EfzATDhVqb-RAofnjTp1tDyXP9-eLc";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);
